import { render, staticRenderFns } from "./LeadWorkflowTasks.vue?vue&type=template&id=0c0abb6d&scoped=true"
import script from "./LeadWorkflowTasks.vue?vue&type=script&lang=ts"
export * from "./LeadWorkflowTasks.vue?vue&type=script&lang=ts"
import style0 from "./LeadWorkflowTasks.vue?vue&type=style&index=0&id=0c0abb6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0abb6d",
  null
  
)

export default component.exports